import UserMapper from '../resources/users/UserMapper';
import UserAddressMapper from '../resources/users/UserAddressMapper';
import IdDocumentMapper from '../resources/idDocuments/IdDocumentMapper';
import WalletMapper from '../resources/wallets/WalletMapper';
import WalletAccountMapper from '../resources/walletAccounts/WalletAccountMapper';
import PaymentInstrumentMapper from '../resources/paymentInstruments/PaymentInstrumentMapper';
import PaymentInstrumentDocumentMapper from '../resources/paymentInstrumentDocuments/PaymentInstrumentDocumentMapper';
import BalanceTransactionMapper from '../resources/balanceTransactions/BalanceTransactionMapper';
import PaymentMapper from '../resources/payments/PaymentMapper';
import InvoiceMapper from '../resources/invoices/InvoiceMapper';
import AccountingAccountMapper from '../resources/accountingAccounts/AccountingAccountMapper';
import PaymentFailureMapper from '../resources/paymentFailures/PaymentFailureMapper';
import PaymentApprovalMapper from '../resources/paymentApprovals/PaymentApprovalMapper';
import UnmatchedPaymentMapper from '../resources/unmatchedPayments/UnmatchedPaymentMapper';
import BusinessContractMapper from '../resources/businessContracts/BusinessContractMapper';
import BusinessContractParameterMapper from '../resources/businessContractParameters/BusinessContractParameterMapper';
import BusinessContractRouteMapper from '../resources/businessContractRoutes/BusinessContractRouteMapper';
import BinGroupMapper from '../resources/binGroups/BinGroupMapper';
import SubsidiaryMapper from '../resources/subsidiaries/SubsidiaryMapper';
import CurrencyMapper from '../resources/currencies/CurrencyMapper';
import VatDefinitionMapper from '../resources/vatDefinitions/VatDefinitionMapper';
import BlackWhiteListMapper from '../resources/blackWhiteLists/BlackWhiteListMapper';
import BlackWhiteListItemMapper from '../resources/blackWhiteListItems/BlackWhiteListItemMapper';
import WalletNotificationMapper from '../resources/walletNotifications/WalletNotificationMapper';
import FeeGroupMapper from '../resources/feeGroups/FeeGroupMapper';
import FeeDefinitionMapper from '../resources/feeDefinitions/FeeDefinitionMapper';
import LimitGroupMapper from '../resources/limitGroups/LimitGroupMapper';
import LimitDefinitionMapper from '../resources/limitDefinitions/LimitDefinitionMapper';
import PaymentTransactionMapper from '../resources/paymentTransactions/PaymentTransactionMapper';
import PaymentTransactionLogMapper from '../resources/paymentTransactionLogs/PaymentTransactionLogMapper';
import AccountingAccountItemMapper from '../resources/accountingAccountItems/AccountingAccountItemMapper';
import AccountingAccountTransferMapper from '../resources/accountingAccountTransfers/AccountingAccountTransferMapper';
import UserRolesMapper from '../resources/users/UserRolesMapper';
import VerificationLevelMapper from '../resources/users/VerificationLevelMapper';
import WalletAccountItemMapper from '../resources/walletAccountItems/WalletAccountItemMapper';
import PurchaseMapper from '../resources/purchases/PurchaseMapper';
import ShopConfigurationMapper from '../resources/shopConfigurations/ShopConfigurationMapper';
import RefundMapper from '../resources/refunds/RefundMapper';
import ApprovableAdminActionMapper from '../resources/approvableAdminActions/ApprovableAdminActionMapper';
import DefaultMapper from './DefaultMapper';
import MT940FileMapper from "../resources/mt940Files/MT940FileMapper";
import MT940FileRecordMapper from "../resources/mt940FileRecords/MT940FileRecordMapper";

export const coreWalletMappers = {
	users: new UserMapper(),
	userAddresses: new UserAddressMapper(),
	userRoles: new UserRolesMapper(),
	idDocuments: new IdDocumentMapper(),
	wallets: new WalletMapper(),
	walletAccounts: new WalletAccountMapper(),
	paymentInstruments: new PaymentInstrumentMapper(),
	paymentInstrumentDocuments: new PaymentInstrumentDocumentMapper(),
	balanceTransactions: new BalanceTransactionMapper(),
	payments: new PaymentMapper(),
	invoices: new InvoiceMapper(),
	accountingAccounts: new AccountingAccountMapper(),
	paymentFailures: new PaymentFailureMapper(),
	paymentApprovals: new PaymentApprovalMapper(),
	unmatchedPayments: new UnmatchedPaymentMapper(),
	businessContracts: new BusinessContractMapper(),
	businessContractParameters: new BusinessContractParameterMapper(),
	businessContractRoutes: new BusinessContractRouteMapper(),
	binGroups: new BinGroupMapper(),
	mt940Files: new MT940FileMapper(),
	mt940FileRecords: new MT940FileRecordMapper(),
	subsidiaries: new SubsidiaryMapper(),
	currencies: new CurrencyMapper(),
	vatDefinitions: new VatDefinitionMapper(),
	blackWhiteLists: new BlackWhiteListMapper(),
	blackWhiteListItems: new BlackWhiteListItemMapper(),
	walletNotifications: new WalletNotificationMapper(),
	feeGroups: new FeeGroupMapper(),
	feeDefinitions: new FeeDefinitionMapper(),
	limitGroups: new LimitGroupMapper(),
	limitDefinitions: new LimitDefinitionMapper(),
	paymentTransactions: new PaymentTransactionMapper(),
	paymentTransactionLogs: new PaymentTransactionLogMapper(),
	accountingAccountItems: new AccountingAccountItemMapper(),
	accountingAccountTransfers: new AccountingAccountTransferMapper(),
	verificationLevel: new VerificationLevelMapper(),
	walletAccountItems: new WalletAccountItemMapper(),
	purchases: new PurchaseMapper(),
	shopConfigurations: new ShopConfigurationMapper(),
	refunds: new RefundMapper(),
	approvableAdminActions: new ApprovableAdminActionMapper(),
	_default_: new DefaultMapper()
};

/*
	"If you have written a custom dataProvider for react-admin v2, it will still work with react-admin v3, because we've included a wrapper for legacy Data Providers. No need for a long rewrite."
	https://marmelab.com/blog/2019/10/14/react-admin-v3-data.html
*/
const dataProvider = (type, resource, params) => {
	const mapper = coreWalletMappers[resource] || coreWalletMappers['_default_'];
	return mapper.run({ type, resource, params });
};

export default dataProvider;
